'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Exam from 'academy-shared-js/records/Exam';
import Lesson from 'academy-shared-js/records/Lesson';
import Video from 'academy-shared-js/records/Video';
import ExpandedTrackNavigator from './ExpandedTrackNavigator';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';

const TrackNavigator = ({
  exam,
  currentContentId,
  lessons,
  track,
  trackIntroductionVideo
}) => /*#__PURE__*/_jsx("div", {
  className: "track-navigator",
  "data-test-id": "track-navigator",
  children: !track || !lessons ? /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 100
  }) : /*#__PURE__*/_jsx(ExpandedTrackNavigator, {
    currentContentId: currentContentId,
    exam: exam,
    lessons: lessons,
    track: track,
    trackIntroductionVideo: trackIntroductionVideo
  })
});

TrackNavigator.propTypes = {
  currentContentId: PropTypes.string,
  exam: PropTypes.instanceOf(Exam),
  lessons: ImmutablePropTypes.listOf(Lesson),
  track: ImmutablePropTypes.map,
  trackIntroductionVideo: PropTypes.instanceOf(Video)
};
export default TrackNavigator;